import { Component, OnInit } from '@angular/core';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatCard } from '@angular/material/card';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    imports: [MatToolbar, MatToolbarRow, MatCard]
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
